var $ = require('@alife/alpha-jquery/jquery');

// 参见：[字段类型](http://gitlab.alibaba-inc.com/form/intl-formx/issues/37)
function fieldType(el) {
    var element = $(el),
        type = element.prop('type');

    if (type == 'text' && (/\[\]$/.test(element.prop('name')))) {
        type = 'text-multiple';
    }

    return type;
}

// jquery仅仅会对$el[0]中的第一个元素进行val()操作
var typeHelper = {
        'radio': {
            get: function ($el) {
                // 如果未选择，则默认值为''；
                // 默认值undefined会有个问题，JSON.stringify发现undefined值时，会忽略
                return $el.filter(':checked').val() || '';
            },
            set: function ($el, value) {
                if (!$.isArray(value)) {
                    value = [value];
                }
                $el.val(value);
            }
        },
        'checkbox': {
            get: function ($el) {
                var values = [];
                $el.filter(':checked').each(function () {
                    values.push(this.value);
                });
                if (values.length) {
                    return values;
                } else {
                    return null;
                }
            },
            set: function ($el, values) {
                if (!$.isArray(values)) {
                    values = [values];
                }
                $el.val(values);
            }
        },
        'text-multiple': {
            get: function ($el) {
                var values = [];
                $el.each(function () {
                    if (this.value !== '') {
                        values.push(this.value);
                    }
                });
                if (values.length) {
                    return values;
                } else {
                    return null;
                }
            },
            set: function ($el, values) {
                if (!values) {
                    return;
                }
                $el.each(function (key, el) {
                    el.value = values[key];
                });
            }
        }
    },
    assign = function (method, $el, value) {
        var type = fieldType($el);
        value = value || '';

        switch (type) {
            case 'text':
            case 'hidden':
            case 'password':
            case 'select-multiple':
            case 'textarea':
                if ('set' == method) {
                    $el.val(value);
                } else {
                    value = $el.val();
                }
                break;
            case 'select-one':
                if ('set' == method) {
                    // select-one时，value必须为字符串，不能为boolean
                    value = value.toString();
                    $el.val(value);
                } else {
                    value = $el.val();
                }
                break;
            case 'text-multiple':
                var name = $el.prop('name');
                $el = $('input:text[name="' + name + '"]');
                value = typeHelper[type][method]($el, value);
                break;
            case 'radio':
            case 'checkbox':
                // 防止只传radio或checkbox中的一个元素
                if ($el.length === 1) {
                    var name = $el.prop('name'),
                        selector = 'input:' + type + "[name='" + name + "']";
                    $el = $(selector);
                }
                value = typeHelper[type][method]($el, value);
                break;
        }

        return value;
    };


module.exports = {
    val: function (selector, value) {
        var element = $(selector);

        if (element.length === 0) return undefined;

        if (arguments.length == 2) {
            return assign('set', element, value);
        } else {
            return assign('get', element);
        }
    },
    type: fieldType
};


